import { Controller } from '@hotwired/stimulus';
import { elementVisible } from '@inked/utilities';

export class DisplayWhenCheckedController extends Controller {
  static targets = ['item'];
  static values = {
    controlsSelector: {
      type: String,
      default: 'button, input, select, textarea',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    toggleOnConnect: {
      type: Boolean,
      default: true,
    },
    toggleSelector: String,
  };

  connect() {
    if (!this.toggleOnConnectValue) return;

    this.refresh();
  }

  refresh() {
    this.element.querySelectorAll(this.#toggleSelector)
      .forEach(toggle => toggle.dispatchEvent(new Event('input')));
  }

  toggle(event) {
    if (!this.hasItemTarget) return;

    if (this.multipleValue) {
      const values = event.target.type === 'checkbox'
        ? [...this.element.querySelectorAll(this.#toggleSelector)].map(toggle => toggle.value)
        : event.target.checked ? [event.target.value] : [];

      return this.#toggleByCheckedValues(values);
    }

    this.#toggleByChecked(event.target.checked);
  }

  #controlDisabled(control, visible) {
    if (control.type === 'hidden') {
      return elementVisible(control.parentElement)
        ? false
        : !visible;
    }

    const field = control.closest('[data-controller~="field"]');

    return !(elementVisible(control) || (field && elementVisible(field)));
  }

  #setVisibility(item, visible) {
    item.classList.toggle('hidden', !visible);

    item.querySelectorAll(this.controlsSelectorValue).forEach(control => {
      if (control.closest('[data-display-when-checked-ignore-controls]')) return;

      control.disabled = this.#controlDisabled(control, visible);
    });
  }

  #toggleByChecked(checked) {
    this.itemTargets.forEach(item => this.#setVisibility(item, checked));
  }

  #toggleByCheckedValues(values) {
    this.itemTargets.forEach(item => {
      this.#setVisibility(
        item,
        item.dataset.value?.split(/\s+/)?.some(itemValue => values.includes(itemValue))
      );
    });
  }

  get #toggleSelector() {
    return this.hasToggleSelectorValue
      ? this.toggleSelectorValue
      : `[data-action~="${this.identifier}#toggle"]:checked`;
  }
}
